var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVetSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-vet-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1482",
    d: "M10.7889 13.9346C10.7889 13.5987 10.6555 13.2765 10.4179 13.039C10.1804 12.8014 9.8582 12.668 9.52226 12.668C9.18632 12.668 8.86413 12.8014 8.62659 13.039C8.38904 13.2765 8.25559 13.5987 8.25559 13.9346C8.25559 14.2706 8.38904 14.5928 8.62659 14.8303C8.86413 15.0679 9.18632 15.2013 9.52226 15.2013C9.8582 15.2013 10.1804 15.0679 10.4179 14.8303C10.6555 14.5928 10.7889 14.2706 10.7889 13.9346ZM10.7605 5.06549C10.7605 4.72955 10.627 4.40737 10.3895 4.16983C10.1519 3.93228 9.82975 3.79883 9.49381 3.79883C9.15787 3.79883 8.83568 3.93228 8.59814 4.16983C8.36059 4.40737 8.22714 4.72955 8.22714 5.06549C8.22714 5.40144 8.36059 5.72362 8.59814 5.96116C8.83568 6.19871 9.15787 6.33216 9.49381 6.33216C9.82975 6.33216 10.1519 6.19871 10.3895 5.96116C10.627 5.72362 10.7605 5.40144 10.7605 5.06549ZM10.7444 9.50007C10.7444 9.16412 10.6109 8.84194 10.3734 8.6044C10.1358 8.36685 9.81367 8.2334 9.47773 8.2334C9.14179 8.2334 8.8196 8.36685 8.58206 8.6044C8.34451 8.84194 8.21106 9.16412 8.21106 9.50007C8.21106 9.83601 8.34451 10.1582 8.58206 10.3957C8.8196 10.6333 9.14179 10.7667 9.47773 10.7667C9.81367 10.7667 10.1358 10.6333 10.3734 10.3957C10.6109 10.1582 10.7444 9.83601 10.7444 9.50007Z",
    fill: "#1B224C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVetSvgrepoCom1);
export default __webpack_public_path__ + "static/media/more-vet-svgrepo-com 1.6bc52fc6be0b2b4dff4750927634dd14.svg";
export { ForwardRef as ReactComponent };